<kc-dialog>
  <ng-template #contentTemplate>
    <div class="search-modal">
      <div class="search-modal__header">
        <form [formGroup]="searchForm">
          <kc-input
            class="search-modal__input"
            prefixIcon="search"
            placeholder="Search tokens"
            formControlName="query"
            variant="search"
          />
        </form>
      </div>

      <div #scrollContainer class="search-modal__body">
        @if (loading() && searchResults().length === 0) {
          <div class="search-modal__skeleton">
            @for (i of [1, 2, 3, 4, 5]; track i) {
              <div class="skeleton-item"></div>
            }
          </div>
        } @else if (searchResults().length > 0) {
          @for (market of searchResults(); track trackMarket($index, market)) {
            <div
              class="token-row"
              tabindex="0"
              role="button"
              (click)="openToken(market)"
              (keydown.enter)="openToken(market)"
              (keydown.space)="$event.preventDefault(); openToken(market)"
            >
              <app-token-logo
                [logoUrl]="market.metadata?.logoUrl"
                [label]="labelFor(market)"
              />
              <div class="token-row__info">
                <span class="token-row__name">
                  @if (tickerFor(market); as ticker) {
                    <span class="token-row__ticker">{{ ticker }}</span>
                  }
                  @if (nameFor(market); as name) {
                    <span>{{ name }}</span>
                  } @else if (!tickerFor(market)) {
                    <span>{{ labelFor(market) }}</span>
                  }
                </span>
                <span class="token-row__sub">
                  {{ shortTokenId(market.tokenIdHex) }}
                </span>
              </div>
              <kc-icon
                iconClass="chevron-right"
                size="sm"
                color="var(--kc-color-gray-500)"
                class="token-row__arrow"
              />
            </div>
          }
        } @else if (currentQuery.trim()) {
          <div class="search-modal__empty">
            <span class="search-modal__empty-title">No tokens found</span>
            <span class="search-modal__empty-sub"
              >Try a different name, ticker, or paste a token ID.</span
            >
          </div>
        } @else {
          <!-- No query yet and discovery returned nothing (empty or failed
               request) — show guidance instead of a blank dialog. -->
          <div class="search-modal__empty">
            <span class="search-modal__empty-title">Search for a token</span>
            <span class="search-modal__empty-sub"
              >Start typing a name or ticker, or paste a token ID.</span
            >
          </div>
        }
      </div>

      <div class="search-modal__gradient"></div>
    </div>
  </ng-template>
</kc-dialog>
